import { Helmet } from "react-helmet-async";
export default function SEO({ title, description, product }) {
  let ldJson = null;
  if (product) {
    ldJson = [
      {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: product.title,
        image: [product.img],
        description: product.desc,
        brand: {
          "@type": "Brand",
          name: product?.brand ? product.brand : "",
        },
        offers: {
          "@type": "Offer",
          url: window.location.href,
          priceCurrency: "GBP",
          price: product?.price?.toFixed(2),
          availability: "https://schema.org/InStock",
          shippingDetails: {
            "@type": "OfferShippingDetails",
            shippingRate: {
              "@type": "MonetaryAmount",
              value: product.postageCost,
              currency: "GBP",
            },
            shippingDestination: {
              "@type": "DefinedRegion",
              addressCountry: "GB",
            },
          },
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: product?.category
              ? product.category[0].replace("-", " ")
              : "",
            item: `https://www.rentoodle.com/products/${product.category}`,
          },
        ],
      },
    ];
  }
  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {/* End standard metadata tags */}
      {/* Facebook tags */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {/* End Facebook tags */}
      {/* Twitter tags */}
      <meta name="twitter:creator" content="Rentoodle" />
      <meta name="twitter:card" content="website" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {product?.category && product?.category.includes("books") && (
        <meta name="robots" content="noindex"></meta>
      )}
      {/* End Twitter tags */}
      {product && (
        <script type="application/ld+json">{JSON.stringify(ldJson)}</script>
      )}
    </Helmet>
  );
}
